import "./AHeader.css"
import { NavLink } from 'react-router-dom'
import { TypeAnimation } from 'react-type-animation'

const AHeader = () => {
  return (
    <div className="mt-[110px]">
      <div className='about-header'>
        <div className='about-header-content'>
          <h2>
            <TypeAnimation
              style={{ fontFamily: 'seaons-reg' }}
              sequence={[
                `ONE VISION, MANY LANDMARKS`,
                10000
              ]}
              speed={300}
              cursor={false}
            />
          </h2>
        </div>
        <div className='about-header-img' data-aos="fade-up"
          data-aos-duration="1000">
          <NavLink to='/downtown'><img src="./AboutPhotos/Header/square.jpeg" alt="" /></NavLink>
          <NavLink to='/park'><img src="./AboutPhotos/Header/park.jpeg" alt="" className='about-header-3img' /></NavLink>
          <NavLink to='/square'><img src="./AboutPhotos/Header/swiss.jpeg" alt="" /></NavLink>
        </div>
      </div>
    </div>
  )
}

export default AHeader